module.exports = __webpack_public_path__ + "images/1-big.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/1-big.png
 ** module id = 557
 ** module chunks = 0
 **/